import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchAllCompany } from "./companyAPI";

export interface AllCompanyState {
  allcompany: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: AllCompanyState = {
  allcompany: [],
  status: "idle",
};

export const GetAllCompany = createAsyncThunk(
  "AllCompany/fetchAllCompany",
  async (data:any) => {
    const response = await fetchAllCompany(data);
    return response;
  }
);

export const allComapnySlice = createSlice({
  name: "allCompany",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetAllCompany.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetAllCompany.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetAllCompany.fulfilled, (state, action) => {
        state.status = "success";
        state.allcompany = action.payload;
      });
  },
});

export const {} = allComapnySlice.actions;

export const selectAllCompany = (state: RootState) => {
  return state.allCompany.allcompany;
};

export default allComapnySlice.reducer;
